import React from 'react'

export default function PantryDetails() {
    return (
        <div className='PantryDetails'>
            <h1>Pantry Details Here</h1>
        </div>
    )
}
